<template>
    <div class="animated fadeIn lapeks-page">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <button type="button" class="btn btn-back mb-3" @click="$router.go(-1)" name="backBtn">
                <i class="fa fa-angle-left mr-1"></i> Back
            </button>
            <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                <div class="laporan-periode">
                    <h4>Laporan Gadai Baru</h4>
                    <h6>
                        Periode : 
                        <span>{{$helper.changeDateFormat(periodeStart)}}</span>
                        <span v-if="periodeEnd != ''"> - {{$helper.changeDateFormat(periodeEnd)}}</span>
                    </h6>
                </div>
                <b-button variant="pgiBtn" class="mb-0 download-btn" @click="openModalDownload()">
                    <!-- <a v-bind:href="$baseFilePath + filePath" target="_blank">
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a> -->
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
            <b-row>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-laptop"></i>
                                <strong>{{dataGadaiCabangAll.jumlahElek}}</strong>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Gadai Elektronik</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataGadaiCabangAll.nominalElek)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-book"></i>
                                <strong>{{dataGadaiCabangAll.jumlahBpkb}}</strong>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Gadai BPKB</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataGadaiCabangAll.nominalBpkb)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-car"></i>
                                <strong>{{dataGadaiCabangAll.jumlahKend}}</strong>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Gadai Kendaraan</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataGadaiCabangAll.nominalKend)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="table-card">
                <div class="table-responsive-wrapper">
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >   
                        <div class="d-flex search-input-wrapper">
                            <multiselect
                                class="ml-2 mr-2"
                                name="filterCabang"
                                v-model="input.filterCabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih filter cabang --"
                            />
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table show-empty hover
                    :busy="isBusy"
                    :items="dataGadaiCabang" 
                    :fields="fields" 
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    responsive class="custom-data-table mb-0">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data gadai baru.
                    </template>
                    <template v-slot:thead-top>
                        <b-tr>
                            <b-th># </b-th>
                            <b-th colspan="2">Elektronik</b-th>
                            <b-th colspan="2">BPKB</b-th>
                            <b-th colspan="2">Kendaraan</b-th>
                        </b-tr>
                    </template>
                    <template v-slot:cell(jumlahElek)="row">
                        <div class="text-right no-wrap">
                            {{ row.item.jumlahElek }}                 
                        </div>
                    </template>
                    <template v-slot:cell(jumlahKend)="row">
                        <div class="text-right no-wrap">
                            {{ row.item.jumlahKend }}                 
                        </div>
                    </template>
                    <template v-slot:cell(jumlahBpkb)="row">
                        <div class="text-right no-wrap">
                            {{ row.item.jumlahBpkb }}                 
                        </div>
                    </template>
                    <template v-slot:cell(nominalElek)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalElek == null">{{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.nominalElek < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalElek).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                    </template>
                    <template v-slot:cell(nominalKend)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalKend == null">{{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.nominalKend < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalKend).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                    </template>
                    <template v-slot:cell(nominalBpkb)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalBpkb == null">{{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.nominalBpkb < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalBpkb).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                    </template>
                </b-table>
                </div>

                <div class="table-pagination-footer d-flex align-items-center justify-content-between">
                        <div class="limit-wrapper d-flex align-items-center">
                            <span class="limit-label mr-2">Tampilkan</span>
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options" class="limit-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="entries-info ml-3">{{ totalViewText }}</span>
                        </div>
                        <b-pagination class="custom-pagination mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                            prev-text="‹"
                            next-text="›"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
            </div>
        </div>
        <b-modal id="modal-download-excel" content-class="lapeks-modal" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadLink == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-laporan-gadai-baru',
    data() {
        return {
            initStatus: 1,
            isBusy: true,
            input:{
                show: 10,
                filterCabang: null,
            },
            fields: [
                { key: "cabangName", label: "Cabang", sortable: true },
                { key: "jumlahElek", label: "Jumlah", sortable: true },
                { key: "nominalElek", label: "Nominal", sortable: true },
                { key: "jumlahBpkb", label: "Jumlah", sortable: true },
                { key: "nominalBpkb", label: "Nominal", sortable: true },
                { key: "jumlahKend", label: "Jumlah", sortable: true },
                { key: "nominalKend", label: "Nominal", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataGadaiCabangAll : [],
            dataGadaiCabang: [],
            filePath: "",
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            id: '',
            periodeStart: '',
            periodeEnd: '',
            isLoadLink: false,
            filePathDownload: ""
        }
    }, 
    methods: {
        
        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show

            this.id = this.$route.params.id

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getDataGadaiBaru = this.$axios.get(`laporan-eksekutif/gadai-baru?${this.id}`).then(response => {
                this.dataGadaiCabangAll = response.data
                this.dataGadaiCabang = response.data.entries
                this.updateTotalItem()
                console.log(response.data)
            })

            Promise.all([getCabang, getDataGadaiBaru]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
                this.periodeStart = this.id.slice(10, 20)
                if(this.id.length > 21){
                    this.periodeEnd = this.id.slice(29)
                }
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataGadaiBaru(){
            this.dataGadaiCabang = this.dataGadaiCabangAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataGadaiBaru()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.dataGadaiCabangAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.dataGadaiCabang = filteredArray
                this.onFiltered(this.dataGadaiCabang)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.dataGadaiCabang.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        openModalDownload(){

            this.isLoadLink = true

            this.$axios.get(`laporan-eksekutif/gadai-baru/dl?${this.id}`).then(response => {
                
                this.$bvModal.show('modal-download-excel')
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadLink = false
            })
        }
    },
    created() {
        this.init()
    }
}
</script>


<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-hover: #0A5247;
$brass: #C69B6B;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

.lapeks-page { padding-bottom: 30px; }

.filter-card,
.table-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.filter-card { padding: 22px 24px 24px; }
.table-card  { padding: 0; overflow: hidden; margin-bottom: 16px; }

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

// Label varian laporan di dalam kartu tabel
.table-card-label {
    position: relative;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-heading;
    padding: 18px 20px 12px 32px;
    margin: 0;
    border-bottom: 1px solid #EDF2EF;

    &::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 19px;
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background-color: $brass;
    }
}

// Filter
.filter-section {
    .filter-controls-row {
        display: flex;
        align-items: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    .filter-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .filter-sublabel {
        font-size: 11.5px;
        font-weight: 600;
        color: $ink-body;
    }

    .range-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .range-sep { font-size: 12px; color: $ink-muted; flex-shrink: 0; }

    ::v-deep .filter-input,
    .filter-select {
        height: 38px;
        border-radius: 8px;
        border: 1px solid $input-border;
        font-size: 13px;
        color: $ink-body;
        padding: 6px 14px;
        background-color: #FFFFFF;

        &::placeholder { color: #8C9F98; font-size: 12.5px; }

        &:focus {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            outline: none;
        }
    }

    ::v-deep .filter-input.input-days { width: 110px; }
    .filter-select { padding: 6px 12px; width: 180px; max-width: 100%; }

    .filter-multiselect-wrapper {
        width: 220px;
        max-width: 100%;

        ::v-deep .multiselect {
            min-height: 38px;

            .multiselect__tags {
                min-height: 38px;
                height: 38px;
                padding: 6px 30px 0 12px;
                border-radius: 8px;
                border: 1px solid $input-border;
                background: #FFFFFF;
                font-size: 13px;
                color: $ink-body;
            }

            .multiselect__placeholder {
                margin-bottom: 0;
                padding-top: 2px;
                color: #8C9F98;
                font-size: 12.5px;
            }

            .multiselect__single {
                margin-bottom: 0;
                padding-top: 2px;
                font-size: 13px;
                color: $ink-body;
                line-height: 20px;
            }

            .multiselect__select { height: 36px; width: 32px; padding: 4px 6px; }

            &.multiselect--active .multiselect__tags {
                border-color: $deep-pine;
                box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            }
        }
    }
}

.btn-filter-search {
    width: 40px;
    height: 38px;
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: $deep-pine-hover; border-color: $deep-pine-hover; }
    &:disabled { opacity: 0.7; cursor: not-allowed; }
}

.btn-filter-reset {
    height: 38px;
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    font-size: 12.5px;
    font-weight: 500;
    padding: 6px 18px;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
}

.table-responsive-wrapper { overflow-x: auto; }

.custom-data-table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;

    ::v-deep thead th {
        background-color: #F6F7F6;
        border-top: none;
        border-bottom: 1px solid #ECEFEC;
        font-size: 11px;
        font-weight: 600;
        color: #7E918B;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 14px 20px;
        vertical-align: middle;
        white-space: nowrap;
    }

    ::v-deep tbody tr {
        transition: background-color 0.15s ease;

        &:hover { background-color: #F8FAF9; }

        td {
            padding: 16px 20px;
            border-top: 1px solid #EDF2EF;
            border-bottom: none;
            vertical-align: middle;
            font-size: 13px;
            color: $ink-body;
            font-weight: 500;
        }

        &:first-child td { border-top: none; }
    }
}

.table-pagination-footer {
    border-top: 1px solid #EDF2EF;
    padding: 16px 20px 4px;

    .limit-label { font-size: 12.5px; color: $ink-muted; }

    .limit-select {
        height: 32px;
        width: 70px;
        border-radius: 6px;
        border: 1px solid $input-border;
        font-size: 12.5px;
        color: $ink-body;
        padding: 2px 8px;
        background-color: #FFFFFF;
    }

    .entries-info { font-size: 12px; color: $ink-muted; }
}

.custom-pagination {
    ::v-deep .page-item {
        margin: 0 2px;

        .page-link {
            border-radius: 6px !important;
            border: 1px solid $input-border;
            color: $ink-body;
            font-size: 12px;
            font-weight: 500;
            min-width: 32px;
            height: 32px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #FFFFFF;
            box-shadow: none !important;

            &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
        }

        &.active .page-link {
            background-color: $deep-pine !important;
            border-color: $deep-pine !important;
            color: #FFFFFF !important;
            font-weight: 700;
        }

        &.disabled .page-link {
            opacity: 0.45;
            background-color: #FAFCFA;
            border-color: #E2E7E3;
            color: #A0B0AA;
            cursor: not-allowed;
        }
    }
}

// Tombol Back pada halaman laporan cetak
.btn-back {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 600;
    padding: 7px 16px;
    transition: all 0.2s ease;

    &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
}
</style>
